import { createFileRoute } from '@tanstack/react-router'
import { DokumenList } from '../../../../components/DokumenList'

export const Route = createFileRoute('/platform/desa/$desaId/dokumen')({
  component: () => {
    const { desaId } = Route.useParams()
    return <DokumenList desaId={desaId} />
  },
})
